import React from 'react'
import router from 'next/router'


function HomePaginator({ last_page }) {

    const go_last_page = () => {
        var new_page = Number(last_page)

        router.push({
            pathname: router.query.url,
            query: { ...router.query, page: new_page }
        }, undefined, { shallow: true, scroll: true });
    }

    const go_first_page = () => {
        var new_page = Number(1)

        router.push({
            pathname: router.query.url,
            query: { ...router.query, page: new_page }
        }, undefined, { shallow: true, scroll: true });
    }

    const go_next_page = () => {
        var new_page = (Number(router.query.page) <= 1 || router.query.page == null) ? (2) : (Number(router.query.page) + 1)

        router.push({
            pathname: router.query.url,
            query: { ...router.query, page: new_page }
        }, undefined, { shallow: true, scroll: true });
    }

    const go_prev_page = () => {
        var new_page = (Number(router.query.page) <= 1 || router.query.page == null) ? (1) : (Number(router.query.page) - 1)

        router.push({
            pathname: router.query.url,
            query: { ...router.query, page: new_page }
        }, undefined, { shallow: true, scroll: true });
    }

    return (
        <>
            <div className="flex flex-row mx-5 lg:mx-0 mb-4 items-end">
                <div className="flex items-center mx-auto mt-6">
                    {/*show a page x of Y*/}
                    {(Number(router.query.page) <= 1 || router.query.page == null) ? (
                        <>
                            <button className="btn btn-disabled btn-sm"><i className="fas fa-fast-backward"></i></button>
                            <button className="btn btn-disabled btn-sm ml-2"><i className="fas fa-backward"></i></button>
                        </>
                    ) : (
                        <>
                            <button className="btn btn-primary btn-sm" onClick={() => go_first_page()}><i className="fas fa-fast-backward"></i></button>
                            <button className="btn btn-primary btn-sm ml-2" onClick={() => go_prev_page()}><i className="fas fa-backward"></i></button>
                        </>
                    )}
                    <div className="mx-8 text-gray-700">
                        {(Number(router.query.page) <= 1 || router.query.page == null) ? (
                            "Page 1 of " + last_page
                        ) : (
                            "Page " + router.query.page + " of " + last_page
                        )}
                    </div>
                    {(Number(router.query.page) < last_page || (router.query.page == null && last_page > 1)) ? (
                        <>
                            <button className="btn btn-secondary btn-sm" onClick={() => go_next_page()}><i className="fas fa-forward"></i></button>
                            <button className="btn btn-secondary btn-sm ml-2" onClick={() => go_last_page()}><i className="fas fa-fast-forward"></i></button>
                        </>
                    ) : (
                        <>
                            <button className="btn btn-disabled btn-sm"><i className="fas fa-forward"></i></button>
                            <button className="btn btn-disabled btn-sm ml-2"><i className="fas fa-fast-forward"></i></button>
                        </>
                    )}
                </div>
            </div>
        </>
    );
}

export default HomePaginator;